module.exports = __webpack_public_path__ + "img/menu-bg8.698d95f8.png";